<style scoped>
  .information >>> .ivu-anchor-ink{height: 100%;right: 72px;top: 0;left: auto;}
  .information >>> .ivu-anchor-link{padding: 23px 0 0px 16px;}
  .line{margin-bottom:25px}
  .information >>> .ivu-anchor-ink-ball{width: 17px;height: 17px;border-radius: 50%;background-color: #00a2e9;left: 50%;border: 3px solid #fff;}
  .information >>> .ivu-select{width: 440px;}
  /*.information >>> .ivu-select-single .ivu-select-selection{border-radius: 20px;height: 40px;line-height: 38px;}*/
  /*.information >>> .ivu-select-input{padding-left: 25px;font-size: 14px;color: #464c5b;}*/
  /*.information >>> textarea.ivu-input{padding-left: 25px;font-size: 14px;color: #464c5b;width: 600px;border-radius: inherit;height: 140px;line-height: 38px;resize:none}*/
  /*.information >>> .ivu-input{padding-left: 25px;font-size: 14px;color: #464c5b;width: 440px;border-radius: 20px;height: 40px;line-height: 38px;}*/
  .information >>> .ivu-input-suffix{top: 4px;}
  .navigation >>> .ivu-input-icon{top: 3px;}
  .information >>> .ivu-switch-checked {border-color: #45db5e;background-color: #45db5e;}
  .inputTips{display: inline-block;margin-right: 24px;font-size: 14px;color: #657180;text-align: right;vertical-align: top;margin-top: 8px;width:100px;}
  .mousedischarge{margin-right:15px;border-radius: 22px;height: 44px;border: 1px solid #d7dde4;display: inline-block;padding: 0 35px 0 5px;line-height: 44px;position: relative}
  .close{position: absolute;right: 0;background-color: red;width: 16px;height: 16px;border-radius: 8px;}
  .name{display: inline-block;font-size: 14px;color: #464c5b;margin-left: 4px;}
  .mouseremove{display: inline-block;line-height: 44px;padding: 0 35px 0 5px;}
</style>

<template>
  <div class="information">
    <!--联系人电话-->
    <div style="margin: 10px 0">
      <p class="inputTips">联系电话<span style="color: red">*</span></p>
      <Input style="width: 440px" v-model="content.contactMobile" placeholder="填写联系人电话"/>
    </div>
    <!--案件来源-->
    <div style="margin: 10px 0;">
      <p class="inputTips">案件来源<span style="color: red">*</span></p>
      <Select filterable style="width: 214px;" v-model="content.caseSource" placeholder="请选择案件来源">
        <Option v-for="(item,index) in caseSourceList" :value="item.id">{{item.name}}</Option>
      </Select>
    </div>
    <!--承办律师-->
    <div style="margin: 10px 0">
      <p class="inputTips">主办律师<span style="color: red">*</span></p>
      <div style="display: inline-block;margin-right: 15px;">
        <div v-if="userList.length>0" class="mousedischarge" style="margin-right:5px;" v-for="(item,index) in content.manager">
          <div class="close" @click="content.manager.splice(index,1)">
            <Icon type="ios-close" color="white" size="20" style="position: absolute;top: -2px;left: -2px;"/>
          </div>
          <Avatar style="vertical-align: top;margin-top: 4px;">{{userList.find((secItem)=>{return secItem.id==item}).name[0]}}</Avatar>
          <p class="name">{{userList.find((secItem)=>{return secItem.id==item}).name}}</p>
        </div>
        <userSelector
            :userList="userList"
            @inputChange="getUserList($event)"
            @selected="content.manager.push($event.id)"
        >
          <template slot="title">
            <Icon type="md-add" color="#00a2e9" size="22" style="line-height: 30px"/>
          </template>
        </userSelector>
      </div>
    </div>
    <!--利冲-->
    <div style="margin: 10px 0;">
      <p class="inputTips" style="vertical-align: middle">是否承诺本所不再代理与聘用人有利益冲突的其他业务<span style="color: red">*</span></p>
      <Select filterable style="width: 214px;" v-model="content.promise" placeholder="请选择">
        <Option value="1">有承诺</Option>
        <Option value="2">未承诺</Option>
      </Select>
    </div>
    <span style="cursor: pointer;color:#bbb" @click="more = !more">更多信息<Icon type="ios-arrow-down"/></span>
    <template v-if="more">
      <!--组织类型-->
      <div style="margin: 10px 0;">
        <p class="inputTips" style="vertical-align: middle">组织类型</p>
        <Select filterable style="width: 214px;" v-model="content.partyType" placeholder="请选择">
          <Option value="个人">个人</Option>
          <Option value="党政机关">党政机关</Option>
          <Option value="企业法人">企业法人</Option>
          <Option value="社会团体">社会团体</Option>
          <Option value="其他">其他</Option>
        </Select>
      </div>
      <!--联系人-->
      <div style="margin: 10px 0">
        <p class="inputTips">联系人</p>
        <Input style="width: 440px" v-model="content.contactName" placeholder="填写联系人"/>
      </div>
      <!--起始日期-->
      <div style="margin: 10px 0">
        <p class="inputTips">起始日期</p>
        <DatePicker type="date" format="yyyy-MM-dd" @on-change="content.startTime = $event" placeholder="选择起始日期"/>
      </div>
      <!--终止日期-->
      <div style="margin: 10px 0">
        <p class="inputTips">终止日期</p>
        <DatePicker type="date" format="yyyy-MM-dd" @on-change="content.endTime = $event" placeholder="选择终止日期"/>
      </div>
      <!--收费金额-->
      <div style="margin: 10px 0">
        <p class="inputTips">收费金额</p>
        <Input v-model="content.projectAmount"  style="width:140px" placeholder="填写收费金额"/> 万元
      </div>
      <!--案源律师-->
      <div style="margin: 10px 0">
        <p class="inputTips">案源律师</p>
        <div style="display: inline-block;vertical-align: middle">
          <div v-if="userList.length>0" class="mousedischarge" style="margin-right: 5px;" v-for="(item,index) in content.source">
            <div class="close" @click="content.source.splice(index,1)">
              <Icon type="ios-close" color="white" size="20" style="position: absolute;top: -2px;left: -2px;"/>
            </div>
            <Avatar style="vertical-align: top;margin-top: 4px;">{{userList.find((secItem)=>{return secItem.id==item}).name[0]}}</Avatar>
            <p class="name">{{userList.find((secItem)=>{return secItem.id==item}).name}}</p>
          </div>
          <userSelector
              :userList="userList"
              @inputChange="getSelectUserList($event)"
              @selected="content.source.push($event.id)"
          >
            <template slot="title">
              <Icon type="md-add" color="#00a2e9" size="22" style="line-height: 30px"/>
            </template>
          </userSelector>
        </div>
      </div>
      <!--其他成员-->
      <div style="margin: 10px 0">
        <p class="inputTips">其他成员</p>
        <div style="display: inline-block;margin-right: 15px;">
          <div class="mousedischarge" style="margin-right:5px;" v-for="(item,index) in content.otherUser">
            <div class="close" @click="content.otherUser.splice(index,1)">
              <Icon type="ios-close" color="white" size="20" style="position: absolute;top: -2px;left: -2px;"/>
            </div>
            <Avatar style="vertical-align: top;margin-top: 4px;">{{userList.find((secItem)=>{return secItem.id==item}).name[0]}}</Avatar>
            <p class="name">{{userList.find((secItem)=>{return secItem.id==item}).name}}</p>
          </div>
          <userSelector
              :userList="userList"
              @inputChange="getUserList($event)"
              @selected="content.otherUser.push($event.id)"
          >
            <template slot="title">
              <Icon type="md-add" color="#00a2e9" size="22" style="line-height: 30px"/>
            </template>
          </userSelector>
        </div>
      </div>
      <!--简要案情-->
      <div style="margin: 10px 0">
        <p class="inputTips">案情简介</p>
        <Input type="textarea" :autosize="{minRows: 5, maxRows: 13}" v-model="content.caseDetails"  style="width: 440px;vertical-align:top;" placeholder="填写简要案情"/>
      </div>
    </template>
    <div style="border-top: 1px solid #d7dde4">
      <Row :gutter="20" type="flex" justify="center" style="margin-top: 40px;">
        <Col span="4">
          <router-link :to="{name:'litigationStep2',query:{id:$route.query.id}}">
            <Button type="primary" style="width:100%">上一步</Button>
          </router-link>
        </Col>
        <Col span="4">
          <Button type="primary" style="width:100%;" @click="createProject">完成创建</Button>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
  import userSelector from '../../../../components/system/userSelector'
  export default {
    name: "step3",//完善信息
    data:function(){
      return {
        more:false,
        projectClassList:[],
        content:{
          mainName:'',
          partyType:'',
          name:'',
          casetAmount:'',
          riskCharge:'',
          promise:'',
          projectAmount:'',
          caseStage:[],
          projectClassSelected:'',
          caseDetails:'',
          causeTypeSelected:'',
          modelTypeSelected:'',
          modelSelected:'',
          createDate:'',
          procedures:'',
          serverContent:'',
          contractor:{
            name:'',
            phone:'',
          },
          payType:'',
          settlementMethod:'',
          receivingUnit:'',
          contactClient:'',
          source:[],
          manager:[],
          otherUser:[],
          //new
          caseType:'',
          cause:'',
          conflictRules:'',
          caseSource:'',
          contactName:'',
          contactMobile:'',
        },
        litigation:[],
        customerPanel:[0,1,2],
        identity:[],
        projectTypeList:[],
        causeTypeList:[],
        modelTypeList : [],
        modelList : [],
        userList:[],
        sourceSelectedList:[],
        managerSelectedList:[],
        otherUserSelectedList:[],
        payTypeList:[],
        receivingUnitList:[],
        caseSourceList:[],
        conflictList:[],
      }
    },
    methods:{
      //案源列表
      getCaseSourceList:function(){
        var _this = this
        _this.caseSourceList = []
        _this.send({
          headers:'C/CaseSourceList',
          success:function (res) {
            for(var index in res){
              _this.caseSourceList.push({id:res[index].CaseSourceId,name:res[index].CaseSourceTitle})
            }
          }
        })
      },
      //利益冲突规则
      getConflictList:function(){
        var _this = this
        _this.conflictList = []
        _this.send({
          headers:'C/CaseConflictList',
          success:function (res) {
            for(var index in res){
              _this.conflictList.push({id:res[index].CaseConflictId,name:res[index].CaseConflictTitle})
            }
          }
        })
      },

      sourceMove:function(keys){
        this.sourceSelectedList = []
        this.content.source = keys
        for(var i=0;i<keys.length;i++){
          for(var j=0;j<this.userList.length;j++){
            if(keys[i]==this.userList[j].key){
              this.sourceSelectedList.push({id:this.userList[j].key,name:this.userList[j].label,icon:this.userList[j].icon})
            }
          }
        }
      },

      managerMove:function(keys){
        this.managerSelectedList = []
        this.content.manager = keys
        for(var i=0;i<keys.length;i++){
          for(var j=0;j<this.userList.length;j++){
            if(keys[i]==this.userList[j].key){
              this.managerSelectedList.push({id:this.userList[j].key,name:this.userList[j].label,icon:this.userList[j].icon})
            }
          }
        }
      },

      otherUserMove:function(keys){
        this.otherUserSelectedList = []
        this.content.otherUser = keys
        for(var i=0;i<keys.length;i++){
          for(var j=0;j<this.userList.length;j++){
            if(keys[i]==this.userList[j].key){
              this.otherUserSelectedList.push({id:this.userList[j].key,name:this.userList[j].label,icon:this.userList[j].icon})
            }
          }
        }
      },

      //获取用户数据
      getUserList:function(searchText){
        var _this = this
        _this.userList = []
        _this.send({
          headers:'C/LawList',
          data:{
            key:searchText||'',
          },
          success:function (res) {
            var tempObj = []
            for(var index in res){
              tempObj.push({id:res[index].UserId,name:res[index].UserName,icon:res[index].UserImg})
            }
            _this.userList = tempObj
          }
        })
      },

      //获取当事人选项信息
      getLitigationStatus:function () {
        var _this = this
        _this.send({
          headers:'C/ShowIdentity',
          success:function (res) {
            _this.identity = []
            for(var index in res.LitigantTypeTitle){
              _this.identity.push({type:res.LitigantTypeTitle[index].LitigantTypeNature,value:res.LitigantTypeTitle[index].LitigantTypeId,label:res.LitigantTypeTitle[index].LitigantTypeTitle})
            }
            _this.litigation = []
            for(var index in res.LitigationLawsuit){
              _this.litigation.push({value:res.LitigationLawsuit[index].LitigationLawsuitId,label:res.LitigationLawsuit[index].LitigationLawsuitName})
            }
          }
        })
      },

      //获取收费方式
      getPayType:function(){
        var _this = this
        _this.payTypeList = []
        _this.send({
          headers:'C/CaseChargeList',
          success:function (res) {
            for(var index in res){
              _this.payTypeList.push({
                id:res[index].CaseChargeId,
                name:res[index].CaseChargeTitle,
              })
            }
          }
        })
      },

      //获取受理机关
      receivingUnit:function(){
        var _this = this
        _this.receivingUnitList = []
        _this.send({
          headers:'C/CaseAcceptanceList',
          success:function (res) {
            for(var index in res){
              _this.receivingUnitList.push({
                id:res[index].CaseAcceptanceId,
                name:res[index].CaseAcceptanceName,
              })
            }
          }
        })
      },

      //新增案件
      createProject:function () {
        var _this = this
        var tempArr = []
        if(
          _this.isEmpty(_this.content.contactMobile)||
          _this.isEmpty(_this.content.caseSource)||
          _this.isEmpty(_this.content.promise)||
          _this.content.manager.length<1
        ){
          _this.$Notice.warning({
            title:'系统消息',
            desc:'请检查必填项是否填写完成！'
          })
          return
        }
        for(var i=0;i<this.client.length;i++){
          tempArr.push({
            LitigationStatusId:1,
            LitigantName:this.client[i].name,
            LitigantLawsuit :this.client[i].litigation,
            // LitigantMobile:this.client[i].mobile,
            LitigantIdCard:this.client[i].IDCardCode,
            LitigantTypeId :this.client[i].identity,
          })
        }
        for(var i=0;i<this.opposed.length;i++){
          tempArr.push({
            LitigationStatusId:2,
            LitigantName:this.opposed[i].name,
            LitigantLawsuit :this.opposed[i].litigation,
            // LitigantMobile:this.opposed[i].mobile,
            LitigantIdCard:this.opposed[i].IDCardCode,
            LitigantTypeId :this.opposed[i].identity,
          })
        }
        _this.send({
          headers:'C/CaseAdd',
          data:{
            CaseActionTypeId:_this.$route.query.id,//业务范围ID
            CaseActionId:_this.content.causeTypeSelected,//案由ID
            CaseActionSecondId:_this.content.modelTypeSelected,//细分模板ID
            CaseActionDetailId:_this.content.modelSelected,//模板ID
            CaseCreateTime:_this.content.createDate,//收案日期
            Procedures:_this.content.procedures,//办案程序
            CaseTitle:_this.content.name,//项目标题
            CaseNum:'',//案件类型ID 刑事、民事、行政、商经ID
            CaseTypeId:_this.$route.query.id,//业务范围ID
            CaseSubjectMatter:_this.content.casetAmount,//争议标的额
            CasePayWay:_this.content.payType,//结算方式ID
            CaseChargeId:_this.content.payType,//结算方式ID
            CaseAcceptanceId:_this.content.receivingUnit,//案件受理机关ID -- */*

            //new
            LitigationArr:tempArr,//当事人
            //base
            CaseClassId:_this.content.caseType,//案件类型ID
            CaseActionInfo:_this.content.cause,//案由
            mainName:_this.content.mainName,//犯罪嫌疑人、被告人 -
            CaseLinkmanTel:_this.content.contactMobile,//联系电话
            CaseSource:_this.content.caseSource,//案件来源
            CaseConflictId:_this.content.promise,//利益冲突规则
            CaseExecutorId:_this.content.manager.toString(),//承办律师
            //existence
            CaseFromId:_this.content.source.toString(),//案源律师
            CaseMemberId:_this.content.otherUser.toString(),//其他律师
            CaseLinkman:_this.content.contactName,//联系人
            CasePayCount:_this.content.projectAmount,//基础、固定收费
            CaseSituation:_this.content.caseDetails,//简要案情
            CaseStage:_this.content.caseStage.toString(),//案件阶段
            //more
            CaseMore:{
              partyType:_this.content.partyType,//组织类型 -
              riskCharge:_this.content.riskCharge,//风险收费 -
              startTime:_this.content.startTime,//起始日期 -
              endTime:_this.content.endTime,//终止日期 -
            },
          },
          success:function (res) {
            // _this.sendApproval(res)\
            _this.$Notice.success({
              title:'系统消息',
              desc:'立项成功！'
            })
            _this.$router.push({name:'projectList'})
          }
        })
      },
      sendApproval:function(caseId) {
        var _this = this
        var tempClientName = []
        var tempClientAddress = []
        var tempOpposedName = []
        for(var i=0;i<_this.client.length;i++){
          tempClientName.push(_this.client[i].name,)
          tempClientAddress.push(_this.client[i].address,)
        }
        for(var i=0;i<this.opposed.length;i++){
          tempOpposedName.push(this.opposed[i].name)
        }
        var tempManageName = []
        for(var i=0;i<_this.content.manager;i++){
          if(_this.userList.find((secItem)=>{return secItem.id==_this.content.manager[i]})){
            tempManageName.push(_this.userList.find((secItem)=>{return secItem.id==_this.content.manager[i]}).name)
          }
        }
        var approval = []
        approval = [
          {"name":"approvalInput","content":{"title":"委托名称","text":tempClientName.toString()}},
          {"name":"approvalInput","content":{"title":"地址","text":tempClientAddress[0]}},
          {"name":"approvalInput","content":{"title":"联系人","text":_this.content.contactName}},
          {"name":"approvalInput","content":{"title":"联系方式","text":_this.content.contactMobile}},
          {"name":"approvalInput","content":{"title":"案由","text":_this.content.cause}},
          {"name":"approvalInput","content":{"title":"承办律师","text":tempManageName.toString()}},
          {"name":"approvalInput","content":{"title":"收费数额","text":_this.content.projectAmount}},
          {"name":"approvalInput","content":{"title":"结算方式","text":_this.content.settlementMethod}},
          {"name":"approvalTextarea","content":{"title":"简要案情","text":_this.content.caseDetails}},
        ]
        _this.send({
          headers:'L/AddApproval',
          data:{
            CaseId: caseId,
            ApprovalModeId:3,
            ApprovalContent:approval,
          },
          success:function () {
            _this.$Notice.success({
              title:'系统消息',
              desc:'立项并发起受案审查成功！'
            })
          }
        })
        _this.$router.push({name:'projectList'})
      }
    },
    components:{
      userSelector:userSelector,
    },
    computed:{
      client:function () {
        return this.$store.state.project.create.step1.client
      },
      opposed:function () {
        return this.$store.state.project.create.step1.opposed
      },
      customerList:{
        get:function () {
          return this.$store.state.project.create.step1.customerList
        },
        set:function (val) {
          this.$store.state.project.create.step1.customerList = val
        }
      },
    },
    client:function () {
      return this.$store.state.project.create.step1.client
    },
    opposed:function () {
      return this.$store.state.project.create.step1.opposed
    },
    mounted:function () {
      this.getCaseSourceList()
      this.getConflictList()
      this.getUserList()
      this.getLitigationStatus()
      this.getPayType()
      // this.receivingUnit()
    },
  }
</script>


